import type { MaintenanceChannels } from '@bcf-vanilla-ts-v1-logic-worker-others/bloc/maintenance/maintenance-channels';
import { UnsubscribableWithWorkerBlocForService } from '@bcf2-v1-platforms/platform-worker/browser/unsubscribable-with-worker-bloc-for-service';
import type { ReactiveControllerHost } from 'lit';
import { filter, map, type Observable, take } from 'rxjs';

export class AppMaintenanceService extends UnsubscribableWithWorkerBlocForService<MaintenanceChannels> {
  constructor(protected override _host: ReactiveControllerHost) {
    super(_host);
    this._initWorkerBloc('maintenance');
  }

  public doRedirectToMaintenance(): Observable<void> {
    return this._subTo('isMaintenanceMode').pipe(
      filter((status: boolean | undefined) => status === true),
      take(1),
      map(() => undefined)
    );
  }
}

export function provideAppMaintenanceService(host: ReactiveControllerHost): AppMaintenanceService {
  return new AppMaintenanceService(host);
}
